<template>
  <div>
    <Bar text="URL版 新規取得" ref="bar" @getCustomer="getCustomer"/>
    <el-row type="flex" justify="end">
      <el-col :span="3">
        <div class="productInfo clearfix" @click="isIntrdouce=!isIntrdouce">
          <p>機能紹介</p>
          <img :src="arrowImg" alt="" class="arrow">
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="3"/>
      <el-col :span="18" class="nextMid">
        <div class="intrdouce" v-show="isIntrdouce">
          <div class="title">機能紹介:</div>
          <div>1.中国国内のサーバ経由してURLに対するタイムスタンプを取得します。よって、中国のサーバーからアクセス可能な静的ウェブページに限られます（Google, Facebook, Twitter などは不可）。また、単一案件に加え、複数案件を一度に処理することも可能です。</div>
          <div>2.URL を入力すると、システム上で自動的に証拠を取得します。</div>
          <div>3.マルチページの一括証拠収集をサポートしております。</div>
          <div class="title">注意事項:</div>
          <div>1.タイムスタンプ取得後は、キャプチャした画像に相違が無いかなどを必ず確認してください。また、取得可能なウェブページはログインを必要とせず、ポップアップウィンドウのないウェブページです。</div>
          <div>2.ログインを必要としないウェブページに限られます。</div>
          <div>3.ポップアップウィンドウがないウェブページに限られます（ポップアップウィンドウが表示された場合は、一部の内容がウィンドウの後ろに隠れる場合があります）。</div>
          <div class="title">料金:</div>
          <div>1.回につきタイムスタンプ1件分の費用が発生します。</div>
        </div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="right"
            label-width="130px"
        >
          <el-form-item
              ref="pageUrl"
              label="種別："
          >
            <el-radio v-model="eviType" label="1">個別申請</el-radio>
            <el-radio v-model="eviType" label="2">一括申請</el-radio>
          </el-form-item>

        </el-form>
        <div class="a-search" v-if="eviType==='1'">
          <div class="colLeft form-container">
            <el-form
                ref="form"
                :model="form"
                :rules="rules"
                label-position="right"
                label-width="130px"
            >
              <el-form-item
                  ref="pageUrl"
                  label="ウェブサイト（URL）："
                  prop="pageUrl"
                  class="inputComponent"
              >
                <el-input
                    v-model="form.pageUrl"
                    allowClear
                    type="textarea"
                    placeholder="証拠を取得するURLを入力してください"
                />
              </el-form-item>
              <el-form-item
                  label="証拠の名称："
                  prop="name"
                  ref="name"
                  class="formName nameInfo"
              >
                <el-input
                    v-model.trim="form.name"
                    placeholder="証拠の名称を入力してください。例：株式会社_商標侵害証拠"
                    :maxlength="maxlengthName"
                    @input="formName = form.name.length"
                    type="textarea"
                    show-word-limit
                >
                </el-input>
                <el-checkbox
                    v-model="form.isCheckName"
                    class="checkGroup"
                    :false-label="0"
                    :true-label="1"
                >証書に記載する
                </el-checkbox>
              </el-form-item>
              <el-form-item
                  ref="applicant"
                  prop="applicant"
                  class="inputComponent"
              >
                <span slot="label">申&nbsp&nbsp請&nbsp&nbsp者：</span>
                <el-input
                    v-model="form.applicant"
                    placeholder="申請者の氏名/社名を入力してください"
                    maxlength="30"
                    @input="formApplicant = form.applicant.length"
                    show-word-limit
                    type="text"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                  ref="remark"
                  style="margin: 8px 0 0 0"
                  :prop="form.isCheckPdf===1 ? 'remark' : 'remark2'"
                  class="formName"
              >
                <span slot="label">説&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp明：</span>
                <el-input
                    v-model="form.remark"
                    type="textarea"
                    :placeholder="form.isCheckPdf!==1 ? '記載は任意です，将来検索しやすくなるように証拠に関する説明（例えば目的、キーワード、タグなど）を記載することができます。' : ''+'将来検索しやすくなるように証拠に関する説明（例えば目的、キーワード、タグなど）を記載することができます。'"
                    :rows="3"
                    :auto-size="{ minRows: 4, maxRows: 4 }"
                    resize="none"
                    show-word-limit
                    :maxlength="maxlength"
                    @input="formRemark = form.remark.length"
                >
                </el-input>
                <el-checkbox :false-label="0"
                             v-model="form.isCheckPdf"
                             class="checkGroup"
                             :true-label="1">証書に記載する
                </el-checkbox>
              </el-form-item>
            </el-form>
            <div class="nextSet">
              <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="6" class="nextMid">
                  <el-button
                      class="nextSetBtn"
                      @click="submitForm('form')"
                      :loading="loading"
                      type="primary"
                  >
                    申請する
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="a-search uploadMain" v-if="eviType==='2'">
          <el-form
              ref="form"
              :model="form"
              label-position="right"
              label-width="130px"
          >
            <el-form-item>
              <div class="uploadText">
                複数件申請用のテンプレートをダウンロードし、テンプレートに従って必要なURLを記入してアップロードしてください。
              </div>
              <el-row type="flex" justify="space-around">
                <el-col :span="1"/>
                <el-col :span="11">
                  <div class="uploadImg" @click="downLoadText()">
                    <i class="el-icon-download"></i>
                  </div>
                  <el-button
                      class="uploadBtn downBtn"
                      @click="downLoadText()"
                      type="primary"
                  >
                    テンプレートのダウンロード(excel)
                  </el-button>
                </el-col>
                <el-col :span="11">
                  <el-upload
                      :multiple="false"
                      ref="uploadImg"
                      action="customize"
                      :http-request="httpRequest"
                      :file-list="fileList"
                      :before-upload="beforeUploadImage"
                  >
                    <div class="uploadImg">
                      <i class="el-icon-plus"></i>
                    </div>
                    <el-button
                        class="uploadBtn"
                        type="primary"
                    >
                      テンプレートのアップロード(excel)
                    </el-button>
                  </el-upload>

                </el-col>
                <el-col :span="6"/>
              </el-row>
            </el-form-item>
          </el-form>
          <div class="guide">
            <div class="guideTitle">ご利用方法：</div>
            <div class="guideInfo">
              <p>「一括申請」とは、一括で複数のウェブページに対してタイムスタンプを申請することを言います。</p>
              <p><span>1.</span>テンプレート（エクセル表）をダウンロードしてください。</p>
              <p><span>2.</span>テンプレート（エクセル表）に証拠となるウェブページの情報を逐次記入し、アップロードしてください。アップロードに成功すれば、タイムスタンプの付与が始まります。</p>
              <p><span>3.</span>それぞれのURL（ウェブページ）に対してタイムスタンプ１つが消費されます。</p>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="3"/>
    </el-row>
    <ModalUpload
        ref="modalUpload"
    />
    <ModalWring
        ref="modalWring"
        @confirm="checkMore(arguments)"
        @close="checkMore(arguments)"
    />
  </div>
</template>
<script>
import {isExternal, isExtName, isApplicantPassName} from '@/plugins/validate'
import {evidencePost, evidenceExportImport} from '@/http/evidence'
import Bar from '@/components/bar'
import ModalUpload from './modalUpload.vue'
import {Loading} from 'element-ui'
import ModalWring from "./modalWring.vue";

let loading

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: 'アップロードしています...',
    background: 'rgba(0,0,0,.4)',
  })
}

function stopLoading() {
  loading.close()
}

export default {
  name: "evidence",
  components: {ModalWring, Bar, ModalUpload},
  data() {
    let validatePass = (rule, value, callback) => {
      if (!isExternal(value)) {
        callback(new Error("正しいURL（\"https \"または \"http \"を含む完全なURL）を入力してください。例：https://www.baidu.com/"));
      } else {
        callback();
      }
    };

    let validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("証拠の名称を入力してください"));
      } else {
        if (isExtName(value)) {
          callback(new Error(' */\\:?"<>|は証拠の名称に利用できません'));
        } else {
          callback();
        }
      }
    };

    let checkRemark = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("説明を入力してください"));
      } else {
        callback();
      }
    };
    return {
      isProgress: false,
      form: {
        applicant: "",
        name: "",
        pageUrl: "",
        pdfWriteName: 1,
        pdfWriteRemark: 0,
        isCheckName: 1,
        isCheckPdf: 0,
        remark: "",
      },
      rules: {
        pageUrl: [
          {required: true, validator: validatePass, trigger: "change"},
        ],
        applicant: [
          {required: true, validator: isApplicantPassName, trigger: "blur"},
        ],
        name: [
          {
            required: true,
            validator: validateName,
            trigger: "change",
          },
        ],
        remark: [{required: true, validator: checkRemark, trigger: "change"}],
        remark2: [{required: false, trigger: "change"}],
      },
      formApplicant: 0,
      maxlength: 100,
      maxlengthName: 50,
      formName: 0,
      formRemark: 0,
      loading: false,
      activeName: "1",
      eviType: "1",
      arrowImg: require("@/assets/images/arrow.png"),
      isIntrdouce: false,
      fileList: [],
      customerDetail: {}
    }
  },
  watch: {
    "form.isCheckPdf": function (newFlag, oldFlag) {
      if (newFlag === 1) {
        this.maxlength = 50;
        this.form.pdfWriteRemark = 1;
      } else {
        this.maxlength = 100;
        this.form.pdfWriteRemark = 0;
        // this.$refs.form.clearValidate("remark");
      }
      if (newFlag === 1 && this.form.remark.length > 50) {
        this.$refs.modalWring.showEdit({
          text: '証書に表示される説明の最大文字数は50文字です',
          data: {},
          type: 1
        })
      }
    },
    "form.isCheckName": function (newFlag, oldFlag) {
      if (newFlag === 1) {
        this.maxlengthName = 50;
        this.form.pdfWriteName = 1;
      } else {
        this.maxlengthName = 70;
        this.form.pdfWriteName = 0;
      }
      if (newFlag === 1 && this.form.name.length > 50) {
        this.$refs.modalWring.showEdit({
          text: '証書に表示される証拠の名称の最大文字数は50文字です',
          data: {},
          type: 2
        })
      }
    },
  },

  methods: {
    // 取证post
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let obj = Object.assign({}, this.form)
          let res = await evidencePost(obj);
          if (res.code === 0) {
            this.$message.success('操作が完了しました')
            this.$router.push('evidence/list')
          } else {
            this.init()
          }
        } else {
          return false;
        }
      });
    },
    // 模板下载
    downLoadText() {
      window.open(
          "https://evidence-public.oss-cn-beijing.aliyuncs.com/evidence/%E3%82%BF%E3%82%A4%E3%83%A0%E3%82%B9%E3%82%BF%E3%83%B3%E3%83%97%E4%B8%80%E6%8B%AC%E5%8F%96%E5%BE%97%E3%83%86%E3%83%B3%E3%83%97%E3%83%AC%E3%83%BC%E3%83%88.xlsx"
      )
    },
    httpRequest(param) {
      const formData = new FormData();
      let files = param.file;
      formData.append("file", files);
      startLoading()
      evidenceExportImport(formData).then(res => {
        if (res.code === 0) {
          this.$refs.bar.init()
          this.$refs.modalUpload.handleShow(res)
        }
        stopLoading()
      }).catch(err => {
        stopLoading()
        this.clearFiles()
      })
    },
    // 上传限制
    beforeUploadImage(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === "xls" || testmsg === "xlsx";
      const imageSize = file.size / 1024 / 1024 <= 100
      if (!extension) {
        this.$message({
          message: 'xls、xlsx形式のファイルをアップロードしてください!',
          type: 'error'
        });
        return false;
      }
      if (!imageSize) {
        this.$message({
          message: `アップロードファイルのサイズは100MB以下にしてください!`,
          type: 'error',
        })
        return false
      }
      return extension || imageSize
    },
    clearFiles() {
      this.$refs.uploadImg.clearFiles()
      this.fileList = []
    },
    getCustomer(data) {
      this.customerDetail = data
      this.form.applicant = data.realName;
    },
    init() {
      this.form.applicant = this.customerDetail.realName
    },
    // 删除
    checkMore(data) {
      if (data[1] === 2) {
        this.form.name = this.form.name.slice(0, 50);
        this.formName = 50;
        this.form.pdfWriteRemark = 1;
      } else if (data[1] === 1) {
        this.form.remark = this.form.remark.slice(0, 50);
        this.formRemark = 50;
        this.form.pdfWriteRemark = 1;
      }
    }
  },
  created() {
  }
}
</script>


<style scoped lang="less">
/deep/ .productInfo {
  width: 65px;
  height: 35px;
  background: #90ADF7;
  font-weight: bold;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1px;
  border-radius: 0 0 0 50px;
  padding: 2px 7px 5px 19px;
  cursor: pointer;
  text-align: center;
  float: right;
  margin: 4px 0 0;

  p {
    text-align: center;
    height: 18px;
  }

  .arrow {
    width: 12px;
    height: 10px;
  }
}

/deep/ .intrdouce {
  font-weight: 400;
  font-size: 12px;
  color: #404143;
  line-height: 21px;
  margin: 0 0 45px;

  .title {
    font-weight: 400;
    font-size: 14px;
    color: #404143;
    line-height: 16px;
    letter-spacing: 1px;
    margin: 10px 0 5px;
  }
}

/deep/ .a-search {
  textarea {
    height: 85px;
    border-radius: 8px;
    border: 1px solid #E4E7ED;
    resize: none;
  }

  .formName {
    margin: 0 0 30px;

    .checkGroup {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      align-content: center;
      padding-top: 10px;
      position: absolute;
      top: 100%;
      right: 0;
      min-height: 20px;

      .el-checkbox__input {
        width: 12px;
        height: 12px;
        margin: -4px 0 0;
      }

      .el-checkbox__inner {
        border-radius: 4px;

        &:hover {
          border-color: #7FDC68;
        }
      }

      .el-checkbox__input.is-checked .el-checkbox__inner {
        background: #7FDC68;
        border-color: #7FDC68;
        border-radius: 4px;
      }
    }
  }

  .nameInfo {
    margin: 0 0 54px;
  }

  .nextSet {
    margin: 51px 0 0;

    .nextMid {
      display: flex;
      justify-content: flex-end;

      .el-button--primary.is-plain {
        background: #fff;
      }

      .el-button--primary.is-plain:hover, .el-button--primary.is-plain:focus {
        background: #66B1FF;
        border-color: #66B1FF;
      }
    }
  }
}

/deep/ .uploadMain {
  .uploadText {
    font-weight: 400;
    font-size: 12px;
    color: #90ADF7;
    line-height: 14px;
    text-align: left;
    margin: -25px 0 0;
  }

  .el-upload-list {
    display: none !important;
  }

  .el-upload {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .el-col {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 20px 0 0;

    .uploadBtn {
      width: 202px;
      height: 25px;
      background: #FFC855;
      border-radius: 30px;
      border: none;
      text-align: center;
      padding: 0;
      font-size: 12px;
      margin: 4px 0 0;
    }

    .downBtn {
      background: #6A91F0;
    }
  }

  .uploadImg {
    width: 48px;
    height: 46px;
    border-radius: 4px 4px 4px 4px;
    border: 1px dashed #E4E7ED;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
      font-size: 20px;
      color: #E6E9F0;
    }
  }
}

.clearfix:after {
  content: " ";
  display: block;
  clear: both;
  height: 0;
}

.clearfix {
  zoom: 1;
}

.guide {
  .guideTitle {
    font-weight: 400;
    font-size: 14px;
    color: #404143;
    line-height: 16px;
    letter-spacing: 1px;
    margin: 10px 0 5px;
  }
  .guideInfo{
  }
  p {
    font-weight: 400;
    font-size: 12px;
    color: #404143;
    line-height: 26px;
    display: flex;
  }
}

/deep/ .el-form-item {
  margin-bottom: 30px;
}
</style>